import { useGetRichTextValues } from '~/config/useGetRichtTextValues';
import { AlertCopyText, StyledIcon } from './JobAlert.styles';
import { FormattedMessage, useIntl } from 'react-intl';

/**
 * @param {React.KeyboardEvent} event
 * @param {Function} onEnter
 * @returns {void}
 */
export const submitOnEnter = (event, onEnter) => {
  // Number 13 is the "Enter" key on the keyboard
  if (event.keyCode === 13) {
    // Cancel the default action, if needed
    event.preventDefault();
    onEnter();
  }
};

/**
 * @param {JobAlertWithFiltersProps} props
 * @returns {React.ReactElement} The rendered component
 */
export const JobAlertWithFilters = ({ filters }) => {
  const intl = useIntl();
  const { richTextValues } = useGetRichTextValues();

  if (filters && filters.length > 0) {
    return (
      <>
        <AlertCopyText state={''}>
          <FormattedMessage
            id="jobAlert.withFiltersText"
            values={{
              filters: filters.map((filter) => filter.name).join(', '),
            }}
          />
          <br />
          <br />
          <FormattedMessage
            id="jobAlert.privacyText"
            values={{
              disclaimerUrl: (chunks) => (
                <a href={richTextValues.disclaimerUrl}>{chunks}</a>
              ),
              privacyPolicyUrl: (chunks) => (
                <a href={richTextValues.privacyPolicyUrl}>{chunks}</a>
              ),
            }}
          />
        </AlertCopyText>
      </>
    );
  }

  return <></>;
};

/**
 * @param {object} props
 * @param {string} props.state
 * @param {Function} props.resetState
 * @param {number} props.jobAdsCount
 * @returns {React.ReactElement | null} The rendered component
 */
export const RenderCopyText = ({ state, resetState, jobAdsCount }) => {
  const intl = useIntl();
  if (state === 'success') {
    return (
      <AlertCopyText state={state} jobAdsCount={jobAdsCount}>
        <StyledIcon icon="CHECK" $status={'success'} />
        {intl.formatMessage({
          id: 'jobAlert.successText',
        })}
      </AlertCopyText>
    );
  }

  if (state === 'error') {
    return (
      <div onClick={() => resetState()}>
        <AlertCopyText state={state}>
          <StyledIcon icon="CLOSE" $status={'error'} />
          {intl.formatMessage({
            id: 'jobAlert.errorText',
          })}
        </AlertCopyText>
      </div>
    );
  }

  return null;
};
